<template>
  <div class="main">
    <div id="formTable" style="height: 36px; magin: 0; padding-top: 6px">
      <Form :model="tableForm" :label-width="80" style="margin: 0">
        <Row>
          <Col span="24" style="display: flex">
            <FormItem label="车牌号">
              <Input
                @on-focus="openVideo = true"
                v-model="tableForm.carNo"
                placeholder="点击选择车牌号"
                style="width: 180px"
              ></Input>
            </FormItem>
            <FormItem label="通道号">
              <Select v-model="channel" size="small" style="width: 100px">
                <Option :value="0">所有通道</Option>
                <Option :value="1">1通道</Option>
                <Option :value="2">2通道</Option>
                <Option :value="3">3通道</Option>
                <Option :value="4">4通道</Option>
              </Select>
            </FormItem>
            <FormItem label="时间段"></FormItem>
            <DatePicker
              type="datetime"
              v-model="startEndTime[0]"
              style="width: 180px"
            ></DatePicker>
            <span style="margin: 4px 4px 0 4px">至</span>
            <DatePicker
              type="datetime"
              v-model="startEndTime[1]"
              style="width: 180px"
            ></DatePicker>
            <Button
              style="margin-left: 20px; height: 30px"
              type="primary"
              @click="chaxun"
              >立即查询</Button
            >
          </Col>
        </Row>
      </Form>
    </div>
    <div id="vvideo">
      <div id="videoHistoryWrap">
        <div id="videoHistory"></div>
      </div>
      <div id="ctvideo">
        <videoTool @play="bofang" ref="videoTool" @alot="alot"></videoTool>
      </div>
    </div>
    <Drawer
      title="车辆选择"
      placement="left"
      :closable="false"
      v-model="openVideo"
      width="250"
      :styles="{ padding: 0 }"
    >
      <p slot="header" style="display: none">选择车辆</p>
      <my-tree
        ref="fleetTree"
        modal="video"
        @car="reCarNo"
        v-if="openVideo"
        filterGroup="车辆"
      ></my-tree>
    </Drawer>
    <Modal width="300" v-model="openDetail" title="历史片段详情" footer-hide>
      <Row>
        <Col span="24"
          ><ly-form-item label="通道号" lw="6">{{
            alotItem.channel
          }}</ly-form-item></Col
        ><Col span="24"
          ><ly-form-item label="文件大小" lw="6"
            >{{ alotItem.size }}M</ly-form-item
          ></Col
        >
        <Col span="24"
          ><ly-form-item label="开始时间" lw="6">{{
            alotItem.begintime2
          }}</ly-form-item></Col
        ><Col span="24"
          ><ly-form-item label="结束时间" lw="6">{{
            alotItem.endtime2
          }}</ly-form-item></Col
        ><Col span="24"
          ><ly-form-item label="设备号" lw="6">{{
            alotItem.device
          }}</ly-form-item></Col
        ><Col span="24"
          ><ly-form-item label="片段时长" lw="6"
            >{{ alotItem.duration }}分钟</ly-form-item
          ></Col
        >
      </Row>
      <Row style="margin-top: 30px">
        <Col span="12"
          ><Button long @click="bofang(alotItem)">回放片段</Button></Col
        ><Col span="12"
          ><Button long type="primary" @click="downloadFile"
            >下载片段</Button
          ></Col
        >
      </Row>
    </Modal>
  </div>
</template>
<script>
import videoTool from "./videoTool.vue";
import myTree from "../locate/locateToolCarPerson.vue";
let playList = [];
let player = null;
let tidObj = null;
let allChannelArr = [];
export default {
  components: { videoTool, myTree },
  data() {
    return {
      isPlay: false,
      startEndTime: [new Date(Date.now() - 3600 * 1000 * 4), new Date()],
      channel: 0, //1078协议设备，通道号传0表示查所有通道。GA系列设备传1,2,3,4这种
      openVideo: false,
      playing: {},
      tableForm: {
        carNo: "",
        deviceNo: "",
      },
      recolist: [],
      start: 0, //时间戳，用来显示时间轴
      end: 0, //时间戳，用来显示时间轴
      list: [],
      openDetail: false,
      alotItem: {
        start: 0,
        channel: 1,
        device: "16200135025",
        end: 0,
        filesize: 0,
      },
    };
  },
  methods: {
    beforCcreatePlayer() {
      if (player != null) {
        player.destroy();
        player = null;
        playList = [];
        tidObj = null;
        this.videoModal = false;
        this.isPlay = true;
        setTimeout(() => {
          this.createPlayer();
        }, 100);
      } else {
        this.createPlayer();
      }
    },
    createPlayer() {
      player = new byskplayer({
        id: "videoHistory", //容器
        baseURL: "wss://videostream.car900.com/", //路径
        //baseURL: 'wss://videostream.car900.com/07B7ED0A57724C7705F2C27E13ED57DA',
        // userkey: "c4d1fbb6-2dc5-4f86-a5da-893f80e9d80a", //客户代码
        userkey: "2161e23a-4d3b-4d1a-bf0a-cafd56f9c6f8", //客户代码
        //userkey: '9c6386c7-4987-4a30-ac90-43ad22900a9f',
        isReal: false, //是否实时
        isRecord: true, //是否回放
        userId: "apidemo", //用户id,
        click: this.onPlayClick,
        playstart: this.onPlayStart,
        playend: this.onPlayEnd,
        isSwitchCodetypeOnFullscreen: false, //全屏是否切换高清，默认false
      });

      //player.poster = "static/poster.png"; //设置预览图片
      player.setPlayerNum(1); //设置视频画面
    },

    chaxun() {
      if (
        this.tableForm.carNo.length == 0 ||
        this.startEndTime[0].length == 0 ||
        this.startEndTime[1].length == 0
      ) {
        this.$Message.error("车牌号或时间段必须填写完整");
        return;
      }
      this.utils.loading(this, "加载中");
      let params = {
        device: this.tableForm.deviceNo, //终端号
        channel: this.channel, //通道号
        protocolType: 1, //协议类型，1：GF-1078，2：GA系列
        begintime: Math.round(this.startEndTime[0].getTime() / 1000), //开始时间（时间戳，精确至秒）
        endtime: Math.round(this.startEndTime[1].getTime() / 1000), //结束时间（时间戳，精确至秒）
        alarmSign: 0, //报警类型（目前只支持：0）
      };
      player.record.query(params, (res) => {
        this.$Spin.hide(); //关闭加载
        if (res.status == 1) {
          this.recolist = res.recordfiles;

          this.chuli();
        }
      });
    },

    bofang(v) {
      this.openDetail = false;
      if (this.isPlay) {
        this.close();
      }
      setTimeout(() => {
        this.playing = v;

        this.isPlay = true;
        this.videoModel = true;
        let playerType = 0;
        if (this.tableForm.deviceModel.indexOf("GH11") != -1) {
          playerType = 1;
        }
        let params = {
          device: this.tableForm.deviceNo,
          channel: v.channel,
          protocolType: 1, //协议类型，1：GF-1078,GB-1078;2：GA系列
          begintime: v.start,
          endtime: v.end,
          //endtime: v.begintime / 1000 + 10,
          //fileName:  null,
          playerType: playerType,
        };
        //console.log(params);
        //const T = protocolTypeDom.options[protocolTypeDom.selectedIndex].innerText
        //GB-1078音视频分离
        /* if (['GB-1078'].includes(T)) {
          params.datatype = 0;
        } */

        let obj = playList.find(
          (p) => p.device == device && p.channel == channel
        );
        if (obj) return;
        let tidObj = player.allocate(1);
        if (tidObj.flag == 1) {
          let tid = tidObj.ids[0];
          player.record.open(
            tid,
            params,
            (res) => {
              //console.log(res);
            },
            {
              // hasAudio: !['GB-1078'].includes(T), //GB-1078音视频分开，默认不请求音频
            }
          );
          playList.push({
            ...params,
          });
        } else {
          alert(tidObj.msg);
        }
      }, 200);
    },
    downloadFile() {
      var v = this.alotItem;
      let params = {
        device: v.device,
        channel: v.channel,
        protocolType: 1,
        begintime: v.start,
        endtime: v.end,
        fileName: v.fileName,
        //plate: "测试车辆",
        //vehicleId: "4321",
        //groupId: "1"
      };
      player.ftp.downloadFile(params, (res) => {
        console.log(res);
        if (res.status == 2 && res.media_address) {
          saveAsFile(res.media_address.video_address);
        }
      });
      function saveAsFile(src, filename) {
        let a = document.createElement("a");
        a.href = src;
        a.target = "_blank";
        a.download = filename || src.substr(src.lastIndexOf("/"));
        a.click();
      }
    },
    //Ga设备下载
    GadownloadFile() {
      var v = this.alotItem;
      let params = {
        device: v.device,
        channel: v.channel,
        protocolType: 1,
        begintime: v.start,
        endtime: v.end,

        fileName: null,
        //plate: "测试车辆",
        //vehicleId: "4321",
        //groupId: "1"
      };
      player.gaDownload.downloadFile(params, (res) => {
        console.log(res);
        if (res.status && res.media_address) {
          saveAsFile(res.media_address.video_address);
        }
      });
      function saveAsFile(src, filename) {
        let a = document.createElement("a");
        a.href = src;
        a.target = "_blank";
        a.download = filename || src.substr(src.lastIndexOf("/"));
        a.click();
      }
    },
    close() {
      this.isPlay = false;
      this.start = 0;
      var v = this.playing;
      let device = v.device;
      let channel = v.channel;
      let index = playList.findIndex(
        (p) => p.device == device && p.channel == channel
      );
      let obj = playList[index];
      if (obj)
        player.record.close(
          obj.tid,
          {
            device: obj.device,
            channel: obj.channel,
            protocolType: obj.protocolType,
          },
          (res) => {
            console.log(res);
          }
        );
      playList.splice(index, 1);
    },
    reCarNo(v) {
      this.tableForm = {
        carNo: v.carNo,
        deviceNo: v.deviceNo,
        deviceModel: v.deviceModel,
        deviceProtocol: v.deviceProtocol,
      };
      this.openVideo = false;
    },
    chuli() {
      var z = this.recolist;
      let list = [];
      for (let i = 1; i <= 4; i++) {
        var aa = {
          channel: i,
          times: [],
        };
        list.push(aa);
      }
      let start = Math.floor(this.startEndTime[0].getTime() / 1000);
      let end = Math.floor(this.startEndTime[1].getTime() / 1000);
      //channel
      for (let i = 0; i < z.length; i++) {
        let zz = z[i];

        var obj = {
          //alarmSign: 0,
          start: zz.begintime / 1000,
          channel: zz.channel,
          //codetype: 1,
          //datatype: 0,
          device: zz.device,
          end: zz.endtime / 1000,
          fileName: zz.fileName,
          filesize: zz.filesize,
          size: (zz.filesize / (1024 * 1024)).toFixed(2),
          duration: ((zz.endtime - zz.begintime) / 60000).toFixed(1),
          begintime2: this.utils.time(zz.begintime),
          endtime2: this.utils.time(zz.endtime),
          //storgetype: 1,
        };
        for (let j = 1; j <= 4; j++) {
          if (zz.channel == j) {
            list[j - 1].times.push(obj);
          }
        }

        /* if (zz.channel == 2) {
          list[1].times.push(obj);
        }
        if (zz.channel == 3) {
          list[2].times.push(obj);
        }
        if (zz.channel == 4) {
          list[3].times.push(obj);
        } */
      }
      this.$refs.videoTool.reach(start, end, list);
      console.log(list);
    },
    alot(a, b) {
      this.openDetail = true;
      console.log(b);
      this.alotItem = b;
    },
  },
  mounted() {
    var s = document.createElement("script");
    s.type = "text/javascript";

    s.src = "static/js/byskplayer.js";
    var m = document.getElementById("byscript");
    m.appendChild(s);
    setTimeout(() => {
      this.beforCcreatePlayer();
    }, 200);
  },
  destroyed() {
    location.reload();

    //m.appendChild(s);
  },
};
</script>
<style>
#vvideo {
  width: 100%;
  height: calc(100% - 46px);
}
#videoHistoryWrap {
  width: 100%;
  height: calc(100% - 100px);
  background: black;
}
#ctvideo {
  width: 100%;
  height: 100px;
  padding: 4px;
  background: rgb(88, 88, 88);
  border-top: 6px solid #cecece;
}
</style>


// WEBPACK FOOTER //
// src/components/video/byCarVideoHistory.vue